import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

import { Button, Col, Row, Typography } from "antd";
import SearchInput from "../../../components/Input/SearchInputs/SearchInput";
// import { LoadingOutlined } from "@ant-design/icons";

import {
  onlyDateFormat,
  // handlePdfDownload,
} from "../../../commonFuntions/CommonUtilFunctions";
import DateRangePicker from "../../../components/DateRangePicker/DateRangePicker";
import CustomSelect from "../../../components/SelectableDropdown/CustomSelect/CustomSelect";
import CustomTableWithPagination from "../../../components/CustomTableWithPagination/CustomTableWithPagination";
import {
  // useLazyGetLineofCreditExcelQuery,
  useLazyGetLoCCategoryQuery,
  useCreateNewCategoryMutation,
  useUpdateNewCategoryMutation
} from "../../../apis/forms";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import NoDataFound from "../../../components/EmptyTable/NoDataFound";
import AddNewLoCCategoryModal from "./AddNewLoCCategoryModal/AddNewLoCCategoryModal";
// import { Link } from "react-router-dom";

const { Text } = Typography;

const RupifyLineOfCredits = () => {
  const [searchedValue, setSearchedValue] = useState({});
  const [dateFilter, setDateFilter] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [editCategoryData, setEditCategoryData] = useState(null);
  
  const [dateSearch, setDateSearch] = useState({
    start_date: "",
    end_date: "",
  });
  console.log("🚀 ~ RupifyLineOfCredits ~ dateSearch:", dateSearch)
  const [
    getLineofCreditApi,
    { data: lineOfCreditData, isFetching: isLoading },
  ] = useLazyGetLoCCategoryQuery();
  
  const [createCategoryApi] = useCreateNewCategoryMutation();
  const [updateCategoryApi] = useUpdateNewCategoryMutation();
   // eslint-disable-next-line react-hooks/exhaustive-deps  
  // const [excelApi, { isFetching: exlLoading, data: excelApiData }] =
  //   useLazyGetLineofCreditExcelQuery();

    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getLineofCreditApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (value) => {
    let formattedDate = null;

    switch (value) {
      case "Today":
        formattedDate = dayjs().format("YYYY-MM-DD");
        break;
      case "Yesterday":
        formattedDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
        break;
      case "last_7_day":
        formattedDate = dayjs().subtract(6, "day").format("YYYY-MM-DD");
        break;
      case "last_30_day":
        formattedDate = dayjs().subtract(29, "day").format("YYYY-MM-DD");
        break;
      case "last_60_day":
        formattedDate = dayjs().subtract(59, "day").format("YYYY-MM-DD");
        break;
      case "Custom":
        formattedDate = "Custom";
        break;
      default:
        break;
    }

    const currentDate = dayjs().format("YYYY-MM-DD");
    if (value !== "Custom" && value !== null) {
      if (value === "clear_date") {
        getLineofCreditApi({
          ...(searchedValue?.search && { search: searchedValue?.search }),
          page: 1,
        });
        setDateSearch({
          start_date: "",
          end_date: "",
        });
      } else {
        getLineofCreditApi({
          start_date: formattedDate,
          end_date: currentDate,
          ...(searchedValue?.search && { search: searchedValue?.search }),
          page: 1,
        });
        setDateSearch({
          start_date: formattedDate,
          end_date: currentDate,
        });
      }

      setCurrentPage(1);
    }
    setDateFilter(value);
  };

  const handleChangeRangePicker = (dates, dateStrings) => {
    if (dates && dates?.length === 2) {
      const startDateFormatted = dates[0].format("YYYY-MM-DD");
      const endDateFormatted = dates[1].format("YYYY-MM-DD");
      getLineofCreditApi({
        start_date: startDateFormatted,
        end_date: endDateFormatted,
        ...(searchedValue?.search && { search: searchedValue?.search }),
        page: 1,
      });
      setDateSearch({
        start_date: startDateFormatted,
        end_date: endDateFormatted,
      });
      setCurrentPage(1);
    }
  };
  const handleSearchedValue = (params) => {
    setSearchedValue(params);
    setCurrentPage(1);
  };
  const handlePageChange = async (currPage) => {
    const params = {
      page: currPage,
      ...(searchedValue && { search: searchedValue?.search }),
    };
    setCurrentPage(currPage);
    await getLineofCreditApi(params);
  };
  // const exportOptions = [
  //   {
  //     key: 1,
  //     value: "Excel",
  //     label: "Excel",
  //   },
  // ];
  // const handleExportApi = async () => {
  //   let response = await excelApi({
  //     ...(searchedValue.search && { search: searchedValue.search }),
  //     ...(dateSearch.start_date && { start_date: dateSearch.start_date }),
  //     ...(dateSearch.end_date && { end_date: dateSearch.end_date }),
  //   });

  //   if (response?.status === "fulfilled") {
  //     handlePdfDownload(response?.data?.data?.url);
  //   }

  //   // excelApi();
  // };
  const options = [
    {
      key: 1,
      value: "Today",
      label: "Today",
    },
    {
      key: 2,
      value: "Yesterday",
      label: "Yesterday",
    },
    {
      key: 3,
      value: "last_7_day",
      label: "Last 7 day",
    },
    {
      key: 4,
      value: "last_30_day",
      label: "Last 30 day",
    },
    {
      key: 5,
      value: "last_60_day",
      label: "Last 60 day",
    },
    {
      key: 6,
      value: "Custom",
      label: "Custom",
    },
    {
      key: 7,
      value: "clear_date",
      label: (
        <Col style={{ color: "#006644", fontWeight: "500" }}>Clear Date</Col>
      ),
    },
  ];
  const columns = [
    {
      width: "200px",
      fixed: "left",
      flex: 2,
      title: "Segment",
      key: 1,
      dataIndex: "category",
      render: (params, record) => {
        return <Text>{params}</Text>;
      },
    },
     {
      width: "200px",
      fixed: "left",
      flex: 2,
      title: "Segment name",
      key: 1,
      dataIndex: "category_name",
      render: (params, record) => {
        return <Text>{params}</Text>;
      },
    },
    {
      // fixed: "left",
      flex: 1,
      title: "Start order date",
      width: "250px",
      key: 2,
      dataIndex: "start_order_date",
      render: (params, record) => {
       return <Text>{onlyDateFormat(params)}</Text>;
      },
    },
    {
      // fixed: "left",
      flex: 1,
      title: "Interest/ year",
       width: "200px",
      key: 3,
      dataIndex: "line_of_credit_interest",
      render: (params, record) => {
       return <Text>{params} %</Text>;
      },
    },
    
    {
      // fixed: "left",
      flex: 1,
      title: "Interest after",
      width: "200px",
      key: 4,
      dataIndex: "interest_after",
      render: (params, record) => {
       return <Text>{params} days</Text>;
      },
    },

    {
      // fixed: "left",
      flex: 1,
      title: "Terms and conditions",
      width: "200px",
      key: 5,
      dataIndex: "terms_and_conditions",
    },
    
    {
      // fixed: "left",
      flex: 1,
      title: "Partner LOC fees",
      width: "200px",
      key: 6,
      dataIndex: "mob_partner_fees",
      render: (params, record) => {
       return <Text>{params} %</Text>;
      },
    },
    {
      title: "Actions",
      width: "100px",
      key: "actions",
      render: (_, record) => (
        <Button
          type="link"
          onClick={() => handleEditCategory(record)}
        >
          Edit
        </Button>
      ),
    },
  ];

  const handleEditCategory = (record) => {
    setEditCategoryData(record);
    setAddCategoryModal(true);
  };

  return (
    <>
      <Col style={{ padding: "2rem" }}>
        <Row>
          <Col className="header-container">
            <Text className="heading">Rupifi</Text>
          </Col>
        </Row>
        <Row className="action-container">
          <Col className="action-sub-container">
            <SearchInput
              size={"large"}
              placeholder={"Search by category"}
              getLibraryApi={getLineofCreditApi}
              width={"400px"}
              isLoading={isLoading}
              handleSearchedValue={handleSearchedValue}
            />

            <CustomSelect
              placeholder={"Date"}
              width={"150px"}
              options={options}
              handleChange={handleChange}
              value={dateFilter}
            />
            {dateFilter === "Custom" && (
              <DateRangePicker
                onChange={handleChangeRangePicker}
                format={"DD-MMM-YYYY"}
              />
            )}
            {/* <CustomSelect
              placeholder={"Export"}
              width={"150px"}
              options={exportOptions}
              handleChange={handleExportApi}
              value={exlLoading ? <LoadingOutlined /> : "Export"}
              disabled={exlLoading ? true : false}
              loading={exlLoading}
            />  */}
            </Col>
            <Col className="action-sub-container">
            <Button
              size="large"
              className="create-order-button"
              onClick={() => {setAddCategoryModal(true);}}
            >
              ADD NEW SEGMENT
            </Button>
         
          </Col>
        </Row>
        <Col>
          <CustomTableWithPagination
            className="order-list-table"
            tableDataSource={lineOfCreditData?.data?.results || []}
            tableColumns={columns}
            locale={{
              emptyText: isLoading ? (
                <TableSkeleton length={10} />
              ) : (
                <NoDataFound text={"No line of credit found!"} />
              ),
            }}
            scroll={{ x: "100%" }}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
            itemsPerPage={30}
            totalEntries={
              !isLoading && lineOfCreditData?.data?.pagination?.total_entries
            }
            isLoading={lineOfCreditData?.data?.results?.length && isLoading}
          />
        </Col>
      </Col>
      <AddNewLoCCategoryModal
              addCategoryModal={addCategoryModal}
              setAddCategoryModal={setAddCategoryModal}
              createCategoryApi={createCategoryApi}
              updateCategoryApi={updateCategoryApi}
              editCategoryData={editCategoryData}
              refreshList={getLineofCreditApi}
              onClose={() => setEditCategoryData(null)}
            />
    </>
  );
};

export default RupifyLineOfCredits;
